import React from "react";
import Layout from "../components/layout";
import Caesarview from "../components/apps/caesar/Caesar";

const Hexbindec = () =>{
    return(
        <Layout>
            <Caesarview />
        </Layout>
    );
} 
export default Hexbindec;